<template>
    <div class="component hours-split-total-table mt-50">
        <div class="row">
            <div class="col-12">
                <el-card class="box-card" v-loading="$store.state.cost.analyticsTotalLoading">
                    <!-- <h4 class="title text-left" slot="header">Table</h4> -->
                    <el-table
                        :data="getData"
                        style="width: 100%"
                        :row-class-name="tableRowClassName"
                        :header-cell-class-name="cellStyle"
                        :cell-class-name="cellStyle"
                        :cell-style="cellStyling"
                    >
                        <el-table-column prop="x_label" :label="$store.state.cost.analyticsSwitchValue">
                            <template slot-scope="scope">
                                {{scope.row.x_label | formatVariableName}}
                            </template>
                        </el-table-column>
                        <el-table-column v-for="topHeader of Object.keys($store.state.cost.analyticsTableHeaders)" :key="topHeader" :label="topHeader | formatVariableName">
                            <el-table-column  v-for="col of $store.state.cost.analyticsTableHeaders[topHeader]"
                                              :key="col.col"
                                              :prop="col.col"
                                              :label="col.col_name | formatVariableName"
                                              :sortable=false
                                              :formatter="formatter">
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import { formatString } from '@/functions'
export default {
    data () {
        return {
            loaded: false

        }
    },
    methods: {
        formatter (row, column) {
            let x = this.$store.state.cost.analyticsColumns.find(x => x.col_name === column.property)
            if (row[column.property] === null) {
                return row[column.property]
            } else if (x.format === 'int') {
                return parseInt(row[column.property])
            } else if (x.format === 'perc_0') {
                return String(parseFloat((parseFloat(row[column.property]) * 100)).toLocaleString('en-EN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })) + '%'
            } else if (x.format === 'perc_1') {
                return String(parseFloat((parseFloat(row[column.property]) * 100)).toLocaleString('en-EN', { minimumFractionDigits: 1, maximumFractionDigits: 1 })) + '%'
            } else if (x.format === 'real_2') {
                return String(parseFloat((parseFloat(row[column.property]))).toLocaleString('en-EN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
            } else if (x.format === 'text') {
                return formatString(row[column.property])
            } else if (x.format === 'curr_0') {
                return '€' + String(parseFloat((parseFloat(row[column.property]))).toLocaleString('en-EN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }))
            } else if (x.format === 'curr_2') {
                return '€' + String(parseFloat((parseFloat(row[column.property]))).toLocaleString('en-EN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
            } else {
                return row[column.property]
            }
        },
        cellStyle (param) {
            const { column } = param
            if (column.property !== undefined) {
                if (column.property.includes('prod') && column.property.split('_')[1] !== 'index') {
                    return 'borderLeft'
                }
                if (column.property.includes('hrs_worked')) {
                    return 'borderLeft'
                }
                if (column.property === 'hours' || column.property === 'hours_last_year' || column.property === 'hours_index' || column.property === 'prod_index' || column.property === 'cost_hrs' || column.property === 'cost_hrs_last_year' || column.property === 'cst_hrs_last_year') {
                    return 'borderLeft'
                }
                if (column.property.includes('costs')) {
                    return 'borderLeftThick'
                }
            } else {
                if (column.level === 1 && column.label !== undefined) {
                    return 'borderTopHeader'
                }
            }
        },
        cellStyling (param) {
            const { column } = param
            if (this.$store.state.cost.tableSortedOn !== null) {
                let sort = this.$store.state.cost.tableSortedOn
                if (sort.includes('_')) {
                    sort = this.$store.state.cost.tableSortedOn.split('_')[0]
                }
                let prop = column.property
                if (column.property.includes('_')) {
                    prop = column.property.split('_')[0]
                }
                if (sort !== null && sort !== undefined && (prop === sort)) {
                    return { 'font-weight': 800 }
                }
            }
        },
        tableRowClassName ({ row, rowIndex }) {
            return 'highlight-row'
        }
    },
    computed: {
        getData () {
            if (this.$store.state.cost.analyticsTotalTable.length === 0) {
                return []
            } else {
                return this.$store.state.cost.analyticsTotalTable
            }
        }
    },
    created () {
        this.loading = false
    }
}
</script>
<style lang="scss">
.hours-split-total-table {
    .el-table--border td {
        border-right: none;
    }
    .el-table--border th {
        border-right: none;
    }
    .el-table--border {
        border-left: none;
        border-top: none;
    }
    .el-table--border::after {
        width: 0pxMa;
    }
    .borderLeft {
        border-left: 1px solid #EBEEF5;
    }
    .borderLeftThick {
        border-left: 3px solid #EBEEF5;
    }
    th {
        background-color: #fff !important;
    }
    .borderTopHeader {
        border-bottom: none;
        border-top: none; //3px solid #EBEEF5;
        border-left: 3px solid #EBEEF5;
    }
}
</style>
